
export default {
  name: 'icon-weather',
};
